import numbro from 'numbro';

numbro.setLanguage('en-US');

export const formatMoneyDecimal = (value: number) => {
  return numbro(value).formatCurrency({ mantissa: 2, thousandSeparated: true });
};

export const formatMoneyInteger = (value: number, spaceSeparated = false) => {
  return numbro(value).formatCurrency({ mantissa: 0, thousandSeparated: true, spaceSeparated });
};

export const formatNullableMoneyInteger = (value?: number) => {
  return formatMoneyInteger(value ?? 0);
};

export const currencySymbol = () => {
  return numbro.languageData().currency.symbol;
};

export const formatPercentageInteger = (value: number) => {
  return numbro(value).format({ mantissa: 0, thousandSeparated: true, postfix: '%' });
};
